import { fetchGenerals, createGeneral, updateGeneral, deleteGeneral } from "@/api/general.api";

export default {
  namespaced: true,

  state: {
    generalList: []
  },

  getters: {
    getGeneralById: (state) => (id) => {
      return state.generalList.find(general => general.id === id);
    },
    
    getGeneralByName: (state) => (name) => {
      return state.generalList.find(general => general.name === name);
    },

    sectors(state) {
      return state.generalList.filter(general => general.type === 'SECTOR');
    },

    suppliers(state) {
      return state.generalList.filter(general => general.type === 'SUPPLIER');
    },

    paymentMethods(state) {
      return state.generalList.filter(general => general.type === 'PAYMENT_METHOD');
    },

    unitTypes(state) {
      return state.generalList.filter(general => general.type === 'UNIT');
    }
  },

  mutations: {
    setGeneralList(state, generalList) {
      state.generalList = generalList;
    },
    
    addGeneral(state, general) {
      state.generalList.push(general);
    },
    
    updateGeneral(state, updatedGeneral) {
      const index = state.generalList.findIndex(general => general.id === updatedGeneral.id);
      if (index !== -1) {
        state.generalList.splice(index, 1, updatedGeneral);
      }
    },
    
    removeGeneral(state, generalId) {
      state.generalList = state.generalList.filter(general => general.id !== generalId);
    }
  },

  actions: {
    async initGeneralList({ commit }) {
      const { success, generalList, error } = await fetchGenerals();

      if (success) {
        commit('setGeneralList', generalList);
        return { success: true };
      }

      return { success: false, error };
    },
    
    async addGeneral({ commit }, generalData) {
      const { success, general, error } = await createGeneral(generalData);
      
      if (success) {
        commit('addGeneral', general);
        return { success: true, general };
      }
      
      return { success: false, error };
    },
    
    async updateGeneral({ commit }, generalData) {
      const { success, general, error } = await updateGeneral(generalData);
      
      if (success) {
        commit('updateGeneral', general);
        return { success: true, general };
      }
      
      return { success: false, error };
    },
    
    async deleteGeneral({ commit }, generalId) {
      const { success, error } = await deleteGeneral(generalId);
      
      if (success) {
        commit('removeGeneral', generalId);
        return { success: true };
      }
      
      return { success: false, error };
    }
  }
} 